import AlertDismissible from '../../Shared/Components/AlertDismissible';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Layout from '../../Shared/Layout/LayoutAdmin';
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import { Inertia } from '@inertiajs/inertia';
import { Link, usePage } from '@inertiajs/inertia-react';

const Create = ({ advisers, currentYear }) => {
    const { flash, errors } = usePage().props;

    const [formData, setFormData] = useState({
        adviser_id: '',
        month: '',
        day: '',
        year: currentYear,
        file: null,
    });

    const [fileName, setFileName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    function handleInputChange(e) {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    function handleFileChange(e) {
        const file = e.target.files[0];
        if (file) {
            // Validar que sea PDF
            if (file.type !== 'application/pdf') {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Solo se permiten archivos PDF',
                });
                e.target.value = '';
                return;
            }

            // Validar tamaño (10MB)
            if (file.size > 10 * 1024 * 1024) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'El archivo no debe exceder los 10MB',
                });
                e.target.value = '';
                return;
            }

            setFormData(prev => ({
                ...prev,
                file: file
            }));
            setFileName(file.name);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();

        // Validaciones
        if (!formData.adviser_id) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar un asesor',
            });
            return;
        }

        if (!formData.month) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar un mes',
            });
            return;
        }

        if (!formData.day) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar un día',
            });
            return;
        }

        // Validar que el día sea un número válido
        if (isNaN(formData.day) || formData.day < 1 || formData.day > 31) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'El día debe ser un número válido entre 1 y 31',
            });
            return;
        }

        if (!formData.year) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe ingresar un año',
            });
            return;
        }

        // Validar que el año sea un número válido
        if (isNaN(formData.year) || formData.year < 2020 || formData.year > currentYear) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `El año debe ser un número válido entre 2020 y ${currentYear}`,
            });
            return;
        }

        if (!formData.file) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar un archivo PDF',
            });
            return;
        }

        setIsSubmitting(true);

        // Crear FormData para enviar archivo
        const data = new FormData();
        data.append('adviser_id', formData.adviser_id);
        data.append('month', formData.month);
        data.append('day', formData.day);
        data.append('year', formData.year);
        data.append('file', formData.file);

        Inertia.post(route('commission-reports.store'), data, {
            onSuccess: () => {
                setIsSubmitting(false);
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'El reporte se ha creado correctamente',
                    timer: 2000
                });
            },
            onError: (errors) => {
                setIsSubmitting(false);
                console.error('Errors:', errors);
            },
            onFinish: () => {
                setIsSubmitting(false);
            }
        });
    }

    return (
        <Layout>
            <Breadcrumbs
                texts={['Reportes de Comisiones', 'Nuevo Reporte']}
                links={[route('commission-reports.index')]}
            />

            <div className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title mb-4">Nuevo Reporte de Comisión</h4>

                            {flash.error && (
                                <AlertDismissible variant="danger" message={flash.error} />
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Asesor <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="adviser_id"
                                                value={formData.adviser_id}
                                                onChange={handleInputChange}
                                                isInvalid={!!errors.adviser_id}
                                                required
                                            >
                                                <option value="">Seleccione un asesor...</option>
                                                {advisers.map((adviser) => (
                                                    <option key={adviser.id} value={adviser.id}>
                                                        {adviser.user?.name} {adviser.lastname_ap} {adviser.lastname_am}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {errors.adviser_id && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.adviser_id}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Día <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="day"
                                                placeholder="Día"
                                                min="1"
                                                max="31"
                                                value={formData.day}
                                                onChange={handleInputChange}
                                                isInvalid={!!errors.day}
                                                required
                                            />
                                            {errors.day && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.day}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Mes <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="month"
                                                value={formData.month}
                                                onChange={handleInputChange}
                                                isInvalid={!!errors.month}
                                                required
                                            >
                                                <option value="">Seleccione un mes...</option>
                                                {months.map((month) => (
                                                    <option key={month} value={month}>
                                                        {month}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {errors.month && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.month}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Año <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="year"
                                                placeholder="Ej: 2024"
                                                value={formData.year}
                                                onChange={handleInputChange}
                                                isInvalid={!!errors.year}
                                                required
                                            />
                                            {errors.year && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.year}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Archivo PDF <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept=".pdf,application/pdf"
                                                onChange={handleFileChange}
                                                isInvalid={!!errors.file}
                                                required
                                            />
                                            {fileName && (
                                                <Form.Text className="text-muted">
                                                    Archivo seleccionado: {fileName}
                                                </Form.Text>
                                            )}
                                            {errors.file && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.file}
                                                </Form.Control.Feedback>
                                            )}
                                            <Form.Text className="text-muted d-block mt-1">
                                                Tamaño máximo: 10MB. Solo archivos PDF.
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-end mt-4">
                                    <Link
                                        href={route('commission-reports.index')}
                                        className="btn btn-secondary me-2"
                                    >
                                        Cancelar
                                    </Link>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Guardando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-save me-2"></i>
                                                Guardar Reporte
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Create;
